import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";

const Redirect = (props) => {
  const { token } = props.match.params;
  useEffect(() => {
    if (token)
      setTimeout(() => {
        redirectToResetPassword();
      }, 500);
  }, [token]);

  const redirectToResetPassword = () => {
    localStorage.clear();
    if (props.location.pathname.includes("reset-password")) {
      localStorage.setItem("RESET_TOKEN", token);
      props.history.push("/reset-password");
    } else {
      sessionStorage.setItem("ACTIVATE_TOKEN", token);
      props.history.push("/user-activate");
    }
  };
  return <div>Redirecting...</div>;
};

export default withRouter(Redirect);
